<svg
  width="64"
  height="45"
  viewBox="0 0 64 45"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M62.4348 5H29.5652C28.7008 5 28 5.70077 28 6.56522V8.13043C28 8.99488 28.7008 9.69565 29.5652 9.69565H62.4348C63.2992 9.69565 64 8.99488 64 8.13043V6.56522C64 5.70077 63.2992 5 62.4348 5Z"
    fill="#47858B" />
  <path
    d="M15.7944 2L8.83407 11.282C8.6793 11.4878 8.48215 11.6581 8.25594 11.7811C8.02973 11.9042 7.77974 11.9773 7.52284 11.9955C7.26595 12.0137 7.00815 11.9765 6.76687 11.8865C6.52558 11.7964 6.30643 11.6557 6.12423 11.4737L2.53027 7.87971"
    stroke="#2DB471"
    stroke-width="3.59396"
    stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    d="M62.4348 22.2188H29.5652C28.7008 22.2188 28 22.9195 28 23.784V25.3492C28 26.2136 28.7008 26.9144 29.5652 26.9144H62.4348C63.2992 26.9144 64 26.2136 64 25.3492V23.784C64 22.9195 63.2992 22.2188 62.4348 22.2188Z"
    fill="#47858B" />
  <path
    d="M62.4348 39.4336H29.5652C28.7008 39.4336 28 40.1344 28 40.9988V42.564C28 43.4285 28.7008 44.1292 29.5652 44.1292H62.4348C63.2992 44.1292 64 43.4285 64 42.564V40.9988C64 40.1344 63.2992 39.4336 62.4348 39.4336Z"
    fill="#47858B" />
</svg>
